
<div class="bg-white w-full p-28 max-[1024px]:p-[4rem_1.25rem_2rem_1.25rem] font-rubik">
  <div class="mx-auto max-w-[64rem] flex flex-col gap-16 max-[1024px]:gap-8">
    <div class="flex flex-col gap-4">
      <h5 class="text-[1.5rem] leading-[2.125rem]">Which container is right for you?</h5>
      <p class="text-[1rem] leading-[1.5rem]">Compare conditions and grades</p>
    </div>
    <div class="flex gap-12">
      <template v-if="windowWidth > 950">
        <div
          class="flex flex-col gap-3"
        >
          <button
            v-for="(container, key) in containerStats"
            :key="key"
            class="py-4 px-5 rounded-lg h-[2.75rem] flex items-center text-[#33415599] uppercase text-[0.875rem] leading-[0.75rem] font-semibold text-left text-nowrap"
            :class="[
              { '!bg-[#E0DAD1] !text-[#334155]': key === selectedContainerStatsKey }
            ]"
            @click="selectContainerStats(key)"
          >
            {{ container.title }}
          </button>
        </div>
        <ContainerStatsCard
          :container-stats="selectedContainerStats"
        />
      </template>
      <template v-else>
        <div class="flex flex-col gap-5 w-full">
          <div class="horizontal-scroll pb-1">
            <ContainerStatsCard
              v-for="(container, key) in containerStats"
              :key="key"
              :container-stats="container"
            />
          </div>
          <a 
            href="/solutions/container-sales"
            class="bg-[#3565FC] !text-white py-[0.625rem] px-[1.25rem] rounded-full flex items-center justify-center"
          >
            Explore Products
          </a>
        </div>
      </template>
    </div>
    <div class="flex flex-col gap-4">
      <h5 class="text-[1.5rem] leading-[2.125rem]">What size is my container?</h5>
      <p class="text-[1rem] leading-[1.5rem]">Container Dimensions</p>
    </div>
    <template v-if="windowWidth > 950">
      <ContainerDimensionsTable :container-types-sizes="containerTypesSizes"/>
      <ContainerCapacityTable :container-types-sizes="containerTypesSizes"/>
    </template>
    <template v-else>
      <div class="flex flex-col gap-1">
        <span class="text-[0.875rem] leading-[1.25rem]">Pick a container size</span>
        <div
          class="relative p-3 border border-[#EDE9E3] bg-[#F9F8F6] cursor-pointer rounded-lg flex justify-between items-center select-none"
          @click.stop="toggleContainerTypesSizesDropdown"
        >
          <span class="font-medium text-[1rem] leading-[1.5rem]">
            {{ selectedContainerTypeSizeName }}
          </span>
          <span>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7.64683 9.18828L8 9.54068L8.35317 9.18828L11.0596 6.48773L11.2929 6.72101L8 10.0139L4.70711 6.72101L4.94039 6.48773L7.64683 9.18828Z" fill="#334155" stroke="#334155"/>
            </svg>
          </span>
          <div
            v-if="isContainerTypesSizesDropdownOpen"
            class="absolute w-full left-0 top-[calc(100%+0.25rem)] flex flex-col bg-white border border-[#EDE9E3] rounded-lg max-h-[23rem] overflow-y-auto z-40"
            v-click-outside="() => { isContainerTypesSizesDropdownOpen = false }"
          >
            <span
              v-for="container in containerTypesSizes"
              :key="container.name"
              class="px-5 py-2 text-[0.875rem] leading-[1.25rem] hover:bg-[#EDE9E3]"
              :class="[
                { '!bg-[#334155] text-white': container.name === selectedContainerTypeSizeName }
              ]"
              @click="selectContainerTypeSize(container.name)"
            >
              {{ container.name }}
            </span>
          </div>
        </div>
      </div>
      <SplitContainerTypeSizeTablesView :container-type-size="selectedContainerTypeSize"/>
    </template>
  </div>
</div>
